export const REGISTER_TOKEN_QUERY_PARAMETER = 'token';
